import {
  defaultFont,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  roseColor,
  transition,
  boxShadow,
  headerColor
} from "./material-kit-react.js"
import {colors} from '../components/Theme/WebTheme';

const headerStyle = {
  appBar: {
    display: "flex",
    border: "0",
    borderRadius: "0",
    padding: "0",
    marginBottom: "0",
    color: "#FFFFFF",
    width: "100%",
    backgroundColor: "transparent",
    boxShadow: "none",
    transition: "background-color 180ms ease, box-shadow 180ms ease",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    position: "relative",
    zIndex: "unset"
  },
  absolute: {
    position: "absolute",
    zIndex: "1100"
  },
  fixed: {
    position: "fixed",
    zIndex: "1100"
  },
  container: {
    maxWidth: "1280px",
    width: "100%",
    paddingRight: "28px",
    paddingLeft: "28px",
    marginRight: "auto",
    marginLeft: "auto",
    minHeight: "72px",
    flex: "1",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "nowrap",
    gap: "16px",
    "@media (max-width: 960px)": {
      paddingRight: "16px",
      paddingLeft: "16px",
      minHeight: "60px",
    }
  },
  flex: {
    flex: "0 0 auto"
  },
  title: {
    ...defaultFont,
    lineHeight: "30px",
    fontSize: "18px",
    borderRadius: "3px",
    textTransform: "none",
    color: "inherit",
    padding: "4px 0",
    minWidth: "auto",
    letterSpacing: "unset",
    "&:hover,&:focus": {
      color: "inherit",
      background: "transparent"
    }
  },
  appResponsive: {
    flex: 1,
    overflowY: "auto",
    padding: "12px 12px 16px",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "14px 12px 14px 20px",
    borderBottom: "1px solid rgba(215, 207, 235, 0.14)",
  },
  drawerClose: {
    color: "#FFFFFF !important",
    backgroundColor: "rgba(251, 250, 254, 0.08) !important",
    border: "1px solid rgba(215, 207, 235, 0.18) !important",
    borderRadius: "12px !important",
    "&:hover": {
      backgroundColor: "rgba(118, 40, 255, 0.28) !important",
    },
  },
  drawerFooter: {
    padding: "16px 20px 22px",
    borderTop: "1px solid rgba(215, 207, 235, 0.14)",
    fontFamily: "'Outfit', 'Poppins', sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "1.2px",
    textTransform: "uppercase",
    color: "rgba(251, 250, 254, 0.6)",
    "& strong": {
      display: "block",
      color: "#FFFFFF",
      fontSize: "14px",
      letterSpacing: "0.6px",
      marginTop: "2px",
    },
  },
  primary: {
    backgroundColor: primaryColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(156, 39, 176, 0.46)"
  },
  info: {
    backgroundColor: infoColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 188, 212, 0.46)"
  },
  success: {
    backgroundColor: successColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(76, 175, 80, 0.46)"
  },
  warning: {
    backgroundColor: warningColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(255, 152, 0, 0.46)"
  },
  danger: {
    backgroundColor: dangerColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(244, 67, 54, 0.46)"
  },
  rose: {
    backgroundColor: roseColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(233, 30, 99, 0.46)"
  },
  transparent: {
    backgroundColor: "transparent !important",
    backgroundImage: "none !important",
    background: "transparent !important",
    boxShadow: "none !important",
    paddingTop: "0",
    paddingBottom: "0",
    marginBottom: "0 !important",
    borderRadius: "0 !important",
    borderBottom: "none",
    color: "#FFFFFF",
  },
  dark: {
    color: "#FFFFFF",
    backgroundColor: "#212121 !important",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(33, 33, 33, 0.46)"
  },
  conecta2Dark: {
    color: "#FFFFFF",
    background: "linear-gradient(90deg, #1A0F3B 0%, #221448 55%, #2C195B 100%) !important",
    backgroundColor: "#1A0F3B !important",
    boxShadow: "0 2px 16px rgba(10, 4, 28, 0.45) !important",
    borderRadius: "0 !important",
    padding: "0 !important",
    marginBottom: "0 !important",
    borderBottom: "1px solid rgba(118, 40, 255, 0.22)",
  },
  conecta2Light: {
    color: "#1A0F3B",
    background: "#FFFFFF !important",
    backgroundColor: "#FFFFFF !important",
    boxShadow: "0 2px 14px rgba(26, 15, 59, 0.10) !important",
    borderRadius: "0 !important",
    padding: "0 !important",
    marginBottom: "0 !important",
    borderBottom: "1px solid #EBE7FB",
  },
  white: {
    border: "0",
    padding: "0.625rem 0",
    marginBottom: "20px",
    color: "#555",
    backgroundColor: "#fff !important",
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)"
  },
  header: {
    backgroundColor: headerColor,
    color: colors.Header_Content,
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)"
  },
  brandMark: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 0",
    minWidth: "auto",
    "&:hover": {
      background: "transparent",
    },
  },
  brandLogo: {
    display: "block",
    height: "56px",
    width: "auto",
    transition: "opacity .25s ease",
    "@media (max-width: 599px)": {
      height: "46px",
    },
  },
  brandLogoOverlay: {
    position: "absolute",
    top: "4px",
    left: 0,
  },
  brandLogoHidden: {
    opacity: 0,
  },
  brandImg: {
    height: "48px",
    width: "auto",
    display: "block",
  },
  drawerPaper: {
    border: "none",
    bottom: "0",
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    width: "min(300px, 86vw)",
    ...boxShadow,
    position: "fixed",
    display: "flex",
    flexDirection: "column",
    top: "0",
    height: "100vh",
    right: "0",
    left: "auto",
    visibility: "visible",
    overflowY: "visible",
    borderTop: "none",
    textAlign: "left",
    paddingRight: "0px",
    paddingLeft: "0",
    color: "#FFFFFF",
    background: "linear-gradient(180deg, #1A0F3B 0%, #221448 60%, #2C195B 100%)",
    borderLeft: "1px solid rgba(118, 40, 255, 0.35)",
    boxShadow: "-12px 0 32px rgba(10, 5, 25, 0.45)",
    ...transition
  }
};

export default headerStyle;
